import { css } from "styled-components";

const PhoneValidationStyles = css`
    .phone-validation-card-title {
        font-size: 48px;
        margin-top: 28px;
    }

    .phone-validation-card-subtitle {
        font-size: 24px;
        margin-top: 24px;
        line-height: 36px;
    }

    .phone-validation-card-description {
        font-size: 16px;
        margin-top: 16px;
        line-height: 28px;
        color: #585757;
    }

    .phone-validation-input-card {
        border-radius: 14px;
        padding: 14px 16px 12px 16px;
        width: 100% - 16px;
        border: 1px solid #D9DAE9;
        font-family: Inter, system-ui, -apple-system, sans-serif;
        margin-top: 16px;
    }

    .phone-validation-input-title {
        display: block;
        font-size: 13px;
        font-weight: 500;
        color: #9aa0a6;
        margin-bottom: 4px;
    }

    .phone-validation-input-field {
        width: 100%;
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 500;
        color: #111111;
        background: transparent;
        padding: 0;
    }

    .phone-validation-error-message {
        text-align: center;
        margin-top: 4px;
        color: #a70202;
        font-size: 16px;
        font-weight: 500;
    }

    .resend-otp {
        color: #2E9F3E;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        user-select: none;
        width: 90%;
        display: flex;
        justify-content: end;
        padding: 12px 16px;
        margin-top: 8px;

        &.disabled {
            color: #898989;
            cursor: "not-allowed"
        }
    }

    @media (max-width: 640px) {
        .phone-validation-card-title {
            font-size: 24px;
            margin-top: 18px;
        }

        .phone-validation-card-subtitle {
            font-size: 16px;
            margin-top: 14px;
            line-height: 22px;
        }

        .phone-validation-card-description {
            font-size: 12px;
            margin-top: 14px;
            line-height: 15px;
        }

        .phone-validation-input-card {
            border-radius: 14px;
            padding: 8px 16px;
            width: 100% - 8px;
            margin-top: 12px;
        }

        .phone-validation-input-title {
            font-size: 10px;
        }

        .phone-validation-input-field {
            font-size: 12px;
            font-weight: 400;
            padding: 0;
        }

        .phone-validation-error-message {
            font-size: 14px;
            margin-top: 2px;
        }

        .resend-otp {
            padding: 8px 16px;
            font-size: 12px;
            margin-top: 4px;
        }
    }

`;

export default PhoneValidationStyles;